<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
export default {
  name: 'EberFiles',
  components: {
    draggable
  },
  model: {
    prop: 'files',
    event: 'update'
  },
  props: {
    files: {
      type: Array,
      default () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ''
    },
    handlePreview: Function
  },
  data () {
    return {
      focusing: false,
      list: _.cloneDeep(this.files),
      draggableOptions: {
        draggable: '.eber-file-list__item',
        disabled: this.disabled
      }
    }
  },
  created () {},
  computed: {},
  mounted () {},
  watch: {
    files () {
      this.list = _.cloneDeep(this.files || [])
    },
    disabled (val) {
      this.draggableOptions.disabled = val
    }
  },
  methods: {
    handleMoveEnd (evt) {
      if (evt.oldIndex === evt.newIndex) {
        return
      }
      this.$emit('update', this.list)
      this.$emit('sort', this.list[evt.newIndex], evt.newIndex, evt.oldIndex)
    },
    handleCommand (command) {
      let cs = _.split(command, '_')
      if (_.isEmpty(cs)) {
        return
      }
      let index = cs[1] ? _.toInteger(cs[1]) : -1
      let file = null
      if (index >= 0) {
        file = this.list[index]
      }
      if (!file) {
        return
      }
      this.$emit(cs[0], file)
    }
  }
}
</script>

<template>
  <draggable v-model="list" :options="draggableOptions" @end="handleMoveEnd">
    <transition-group
      tag="ul"
      class="eber-file-list"
      :class="[customClass]"
      name="eber-file-list">
      <li
        v-for="(file, index) in list"
        :key="file.id || index"
        :class="['eber-file-list__item', focusing ? 'focusing' : '', !disabled ? 'hand' : '']"
        tabindex="0"
        @keydown.delete="!disabled && $emit('remove', file)"
        @focus="focusing = true"
        @blur="focusing = false"
        @click="focusing = false">
        <img
          class="eber-file-list__item-thumbnail"
          :src="file.thumbnail"
          @click="handlePreview(file)"
          alt="">
        <div class="eber-file-list__item-tools" v-if="!disabled">
          <el-dropdown
            @command="handleCommand"
            trigger="hover">
            <el-button icon="el-icon-arrow-down" style="padding: 5px;"></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="'remark_' + index" class="image-tool-item" v-if="file.id">
                <i class="el-icon-edit"></i>
                <span>备注</span>
              </el-dropdown-item>
              <el-dropdown-item :command="'remove_' + index" class="image-tool-item delete-item">
                <i class="el-icon-delete"></i>
                <span>删除</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- <span class="eber-file-list__item-actions" v-if="!enableDrag">
          <span
            class="eber-file-list__item-preview"
            v-if="handlePreview"
            @click="handlePreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="eber-file-list__item-delete"
            @click="$emit('remove', file)">
            <i class="el-icon-delete"></i>
          </span>
        </span> -->
      </li>
    </transition-group>
  </draggable>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eber-file-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline;
  vertical-align: top;
}
.eber-file-list__item {
  -webkit-transition: all .5s cubic-bezier(.55,0,.1,1);
  transition: all .5s cubic-bezier(.55,0,.1,1);
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  margin-top: 5px;
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
}
.eber-file-list__item:focus {
  outline-width: 0;
}.eber-file-list__item.hand {
  cursor: pointer;
}
.eber-file-list .eber-file-list__item {
  text-align: center;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
.eber-file-list .eber-file-list__item {
  float: left;
}
.eber-file-list .eber-file-list__item-thumbnail {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: block;
  margin: auto;
  padding: auto;
}
.eber-file-list .eber-file-list__item-tools {
  position: absolute;
  top: 0;
  right: 0;
  cursor: default;
  text-align: center;
  color: #fff;
}
.eber-file-list .eber-file-list__item-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0,0,0,.5);
  -webkit-transition: opacity .3s;
  transition: opacity .3s;
  line-height: 146px;
}
.eber-file-list .eber-file-list__item-actions:hover {
  opacity: 1;
}
.eber-file-list .eber-file-list__item-actions span {
  display: none;
  cursor: pointer;
}
.eber-file-list .eber-file-list__item-actions span+span {
  margin-left: 15px;
}
.eber-file-list .eber-file-list__item-actions:hover span {
  display: inline-block;
}
.eber-file-list__item-delete {
  position: absolute;
  right: 10px;
  top: 0;
  font-size: 12px;
  color: #606266;
  display: none;
}
.eber-file-list .eber-file-list__item-actions .eber-file-list__item-delete {
  position: static;
  font-size: inherit;
  color: inherit;
}
.image-tools li {
  box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  position: relative;
  font-size: 14px;
  padding: 5px 0;
}
.image-tool-item i {
  margin: 0 5px;
}
.delete-item {
  color: #F56C6C;
}
</style>
